























import { Component } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { CoreStoreState } from '../core.store';
import { SwAppHeader } from '../sw-app-header';
import { SwAppFooter } from '../sw-app-footer';
import { SwAppContent } from '../sw-app-content';
import { SwAppNav } from '../sw-app-nav';
import { SwAppTitle } from '../sw-app-title';
import { SwCircleMenu, CircleMenuItem } from '@libs/unified-ui-framework/src/shared/sw-circle-menu';
import { SwAppResponsive } from '../sw-app-responsive';
import { storageService, KEYS } from '@/shared/storage-service';

import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

@Component({
  components: {
    SwAppHeader,
    SwAppFooter,
    SwAppContent,
    SwCircleMenu,
    SwAppNav,
    SwAppTitle,
    SwAppResponsive,
  },
})
export default class SwAppMain extends SwExtendedVue {

  circleMenuItems: CircleMenuItem[] = [
    { menuId: 'menu4', icon: 'shopping-cart',
      desc: 'Contact Sales', href: 'https://www.sonicwall.com/en-us/customers/contact-sales?elqCampaignId=7973' },
    { menuId: 'menu2', icon: 'cloud-stack',
      desc: 'Free Trials', href: 'https://www.sonicwall.com/en-us/resources/trials?elqCampaignId=7974' },
    { menuId: 'menu6', icon: 'archive',
      desc: 'Resources', href: 'https://www.sonicwall.com/en-us/resources' },
    { menuId: 'menu3', icon: 'phone',
      desc: 'Support', href: 'https://www.sonicwall.com/en-us/support' },
    { menuId: 'menu5', icon: 'chatting',
      desc: 'Blog', href: 'https://blog.sonicwall.com/' },
    { menuId: 'menu1', icon: 'firewall',
      desc: 'Product Page', href: 'https://www.sonicwall.com/en-us/products' },
  ];

  @State((state: RootStoreState) => state.CoreStoreModule.circleMenuForcePos)
  circleMenuForcePos: CoreStoreState['circleMenuForcePos'];

  @Getter
  isEmbeddedViewMode: boolean;

  @Getter
  isStandAloneMode: boolean;

  @Getter
  isCircleMenuMode: boolean;

  get circleMenuInitPos() {
    if (this.circleMenuForcePos) {
      return {
        left: this.circleMenuForcePos.left,
        top: this.circleMenuForcePos.top,
      };
    }
    return { left:  100, bottom: 100 };
  }

  highlightCircleMenu() {
    /** toggle the circle menu opened for 3 sec after showing the nav-indicator for 2 sec */
    Promise.resolve()
      /** expand the menu after 2s */
      .then(() => {
        return new Promise((resolve) => {
          setTimeout(() => {
            (this.$refs.circleMenu as SwCircleMenu).toggle(true);
            resolve();
          },         2000);
        });
      })
      /** wait 1s */
      .then(() => {
        return new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });
      })
      /** cycling items each for 1s */
      .then(() => {
        return new Promise((resolve) => {
          let highlightChain = Promise.resolve();
          this.circleMenuItems.forEach((item) => {
            highlightChain = highlightChain.then<void>(() => {
              (this.$refs.circleMenu as SwCircleMenu).highlightItem(item.menuId);
              return new Promise((highlightResolve) => { setTimeout(highlightResolve, 1000); });
            });
          });
          highlightChain
            .then(() => {
              (this.$refs.circleMenu as SwCircleMenu).highlightItem(this.circleMenuItems[0].menuId);
              return new Promise((highlightResolve) => { setTimeout(highlightResolve, 1000); });
            })
            .then(() => {
              (this.$refs.circleMenu as SwCircleMenu).highlightItem(null);
              resolve();
            });
        });
      })
      /** collapse the menu after .5s */
      .then(() => {
        return new Promise((resolve) => {
          setTimeout(() => {
            (this.$refs.circleMenu as SwCircleMenu).toggle(false);
            resolve();
          },         500);
        });
      });
  }

  isMobile() {
    let check = false;
      // tslint:disable-next-line:max-line-length
    (function (a) {
      // tslint:disable-next-line:max-line-length
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor);
    return check;
  }

  mounted() {
    this.$nextTick(() => {
      storageService.get(KEYS.CIRCLE_MENU_HIGHLIGHTED)
        .then((value) => {
          if (value === null) {
            /** the menu never been highlighted, so we do once and remember it */
            this.highlightCircleMenu();
            storageService.set(KEYS.CIRCLE_MENU_HIGHLIGHTED, true);
          }
        })
        .catch(() => {});
    });
  }
}
